export default "__VITE_ASSET__Cm20$qHn__"